import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export class DeleteCustomizedViewsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteCustomizedViews', { ids: ids });
  }
}
